import type { ButtonHTMLAttributes } from "react";

export function RightArrowButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        version="1.1"
        fill="#1a91f0"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9.431 7.257l1.352-1.474 5.893 5.48a1 1 0 0 1 0 1.474l-5.893 5.45-1.352-1.475L14.521 12 9.43 7.257z"></path>
      </svg>
    </button>
  );
}
